import { useQuery } from "@tanstack/react-query"

import { LibraryResponses } from "@tfg/types/endpoints/library"

import { httpClient } from "~/backend/axios.ts"

export const useListInformationRequests = (orgId: string | undefined) =>
  useQuery({
    queryKey: ["organizations", orgId, "information-requests"],
    enabled: !!orgId,
    queryFn: () => {
      return httpClient
        .get<LibraryResponses.InformationRequestDashboard[]>(
          `/organizations/${orgId}/traceability-requests`
        )
        .then((response) => {
          return response.data
        })
    },
  })
